import script from "./QualityIndicatorView.vue?vue&type=script&setup=true&lang=js"
export * from "./QualityIndicatorView.vue?vue&type=script&setup=true&lang=js"

import "./QualityIndicatorView.vue?vue&type=style&index=0&id=db824ad4&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db824ad4"]])

export default __exports__